var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewPassportAddressIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00098 14.0059L4.55258 9.7532C4.84625 9.26375 5.27339 8.86819 5.78392 8.61292L6.36936 8.32021C6.7861 8.11184 7.24563 8.00336 7.71156 8.00336H10.0043",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00195 21.0088L9.76622 18.9259C10.5708 18.6352 11.261 18.0943 11.7356 17.3826L14.7297 12.8927C15.1652 12.2397 15.0791 11.3701 14.5241 10.815V10.815C13.8812 10.1722 12.839 10.1721 12.196 10.8148L10.0045 13.0054H8.00362",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0039 13.0054V7.50312C10.0039 6.12183 11.1237 5.00208 12.5049 5.00208H19.5079C20.8892 5.00208 22.0089 6.12183 22.0089 7.50312V11.5048C22.0089 12.8861 20.8892 14.0058 19.5079 14.0058H14.0056",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0081 8.00332H16.0068",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0082 11.0046H18.0078",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewPassportAddressIcon);
export default __webpack_public_path__ + "static/media/view-passport-address-icon.dcf4a8a56078c7f7e509f1b3987868e1.svg";
export { ForwardRef as ReactComponent };